import { Action } from '../../actions/inbound/index';
import { ActionType } from '../../actions-types';
import { DetailInbound } from '@root/modules/Warehouse/Inbound/Interface';

export type inboundList = {
  id: number;
  name: string;
  email: string;
  productName: string;
  quantity: number;
  status: string;
  updatedAt: string;
  createdAt: string;
  order?: string[];
};

interface inboundListState {
  loading: boolean;
  error: string | null;
  data: inboundList[] | any;
}

const initialState: inboundListState = {
  loading: false,
  error: null,
  data: []
};

const inboundReducer = (
  state: inboundListState = initialState,
  action: Action
): inboundListState => {
  switch (action.type) {
    case ActionType.GET_INBOUND_LIST:
      return {
        ...initialState,
        loading: true,
        error: null,
        data: []
      };
    case ActionType.GET_INBOUND_LIST_SUCCESS:
      return {
        ...initialState,
        loading: false,
        error: null,
        data: action.payload
      };
    case ActionType.GET_INBOUND_LIST_ERROR:
      return {
        ...initialState,
        loading: false,
        error: action.payload,
        data: []
      };
    default:
      return state;
  }
};

// approve inbound

export interface ApproveInbound {
  approvedLoading: boolean;
  error: string | null;
  warehouseComment: {
    warehouseComment: string;
  };
}

const initialApproveInbound: ApproveInbound = {
  approvedLoading: false,
  error: null,
  warehouseComment: {
    warehouseComment: ''
  }
};

// handle approve
export const approveInboundReducer = (
  state: ApproveInbound = initialApproveInbound,
  action: Action
) => {
  switch (action.type) {
    case ActionType.APPROVE_INBOUND:
      return {
        ...initialApproveInbound,
        approvedLoading: true,
        error: null,
        warehouseComment: ''
      };
    case ActionType.APPROVE_INBOUND_SUCCESS:
      return {
        ...initialApproveInbound,
        approvedLoading: false,
        error: null,
        warehouseComment: action.payload
      };

    case ActionType.APPROVE_INBOUND_ERROR:
      return {
        ...initialApproveInbound,
        approvedLoading: false,
        error: action.payload,
        warehouseComment: ''
      };

    default:
      return state;
  }
};

// handle get detail inbound
export interface InitDetailInbound {
  loading: boolean;
  error: string | null;
  data: DetailInbound | any;
}

const initDetailInbound: InitDetailInbound = {
  loading: false,
  error: null,
  data: {
    attachments: [],
    checkPoint: '',
    createdAt: '',
    email: '',
    id: NaN,
    inboundStatus: '',
    name: '',
    products: [],
    sellerComment: '',
    sellerId: NaN,
    shipmentDetail: '',
    shipmentMethod: '',
    shippingPlanEta: '',
    shippingPlanEtd: '',
    status: '',
    updatedAt: '',
    warehouseComment: '',
    warehouseCommentDate: ''
  }
};
export const detailInboundReducer = (
  state: InitDetailInbound = initDetailInbound,
  action: Action
) => {
  switch (action.type) {
    case ActionType.GET_INBOUND_DETAIL:
      return {
        ...initDetailInbound,
        loading: true,
        error: null,
        data: []
      };
    case ActionType.GET_INBOUND_DETAIL_SUCCESS:
      return {
        ...initDetailInbound,
        loading: false,
        error: null,
        data: action.payload
      };
    case ActionType.GET_INBOUND_DETAIL_ERROR:
      return {
        ...initDetailInbound,
        loading: false,
        error: action.payload,
        data: []
      };
    default:
      return state;
  }
};

export interface completeInbound {
  productId: number;
  location: string;
  estimatedQuantity: number;
  deliveredDt: any;
  deliveredQuantity: number;
  availableQuantity: number;
  unAvailableQuantity: number;
  inspectionResult: string;
  otherResultDetail?: string;
}

export interface bodyCompleteInbound {
  importInformations: completeInbound[];
}

export interface bodyCommentWarehouse {
  warehouseComment: string;
}

export interface InitialCompleteInboundType {
  completeLoading: boolean;
  error: string | null;
  completeData: completeInbound[];
}

const initialCompleteInbound: InitialCompleteInboundType = {
  completeLoading: false,
  error: null,
  completeData: [
    {
      productId: NaN,
      location: '',
      estimatedQuantity: NaN,
      deliveredDt: '',
      deliveredQuantity: NaN,
      availableQuantity: NaN,
      unAvailableQuantity: NaN,
      inspectionResult: '',
      otherResultDetail: ''
    }
  ]
};

export const completeInboundReducer = (
  state: InitialCompleteInboundType = initialCompleteInbound,
  action: Action
) => {
  switch (action.type) {
    case ActionType.POST_COMPLETE:
      return {
        ...initialCompleteInbound,
        completeLoading: true,
        error: null,
        data: []
      };
    case ActionType.POST_COMPLETE_SUCCESS:
      return {
        ...initialCompleteInbound,
        completeLoading: false,
        error: null,
        data: action.payload
      };

    case ActionType.POST_COMPLETE_ERROR:
      return {
        ...initialCompleteInbound,
        completeLoading: false,
        error: action.payload,
        data: []
      };
    default:
      return state;
  }
};

export default inboundReducer;
